module.exports = __webpack_public_path__ + "static/media/gameUniformDesignSleb.a1087901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignSleb.png
// module id = 2543
// module chunks = 0